import moment from "moment"
import "./OpenPosition.css"

export type OpenPositionProps = {
  logo?: string
  company?: string
  title?: string
  location?: string
  expireDate?: Date
  expireDateLabel?: string
  url?: string
  urlLabel?: string
}

export function OpenPosition({
  company,
  /*expireDate,
  expireDateLabel,*/
  location,
  logo,
  title,
  url,
  urlLabel,
}: OpenPositionProps) {
  let formattedDate: string = ""

  /*if (expireDate) {
    formattedDate = moment(expireDate).format("DD.MM.YYYY")
  }*/

  return (
    <article className="avlav-openposition">
      <div className="avlav-logo">
        <img src={logo} alt={company} />
      </div>
      <div className="avlav-openposition-detail">
        <p className="avlav-company">{company}</p>
        <h3>{title}</h3>
        <p className="avlav-location">{location}</p>
        {/**<p className="av-lav-date">
          {expireDateLabel} {formattedDate}
        </p>**/}
      </div>
      <a href={url} target="_blank">
        <span className="visible-xs hidden-md">{urlLabel}</span>
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.9468 16.0794C21.9068 15.9994 21.8602 15.9327 21.8068 15.8794L16.4268 10.4994C16.2935 10.3661 16.1368 10.2994 15.9568 10.2994C15.7768 10.2994 15.6202 10.3661 15.4868 10.4994C15.3535 10.6327 15.2868 10.7894 15.2868 10.9694C15.2868 11.1494 15.3535 11.3061 15.4868 11.4394L19.7268 15.6794H10.6668C10.4802 15.6794 10.3235 15.7427 10.1968 15.8694C10.0702 15.9961 10.0068 16.1527 10.0068 16.3394C10.0068 16.5261 10.0702 16.6827 10.1968 16.8094C10.3235 16.9361 10.4802 16.9994 10.6668 16.9994H19.7268L15.4868 21.2394C15.3535 21.3727 15.2868 21.5294 15.2868 21.7094C15.2868 21.8894 15.3535 22.0461 15.4868 22.1794C15.6202 22.3127 15.7768 22.3794 15.9568 22.3794C16.1368 22.3794 16.2935 22.3127 16.4268 22.1794L21.8068 16.8194C21.9002 16.7261 21.9602 16.6094 21.9868 16.4694C22.0135 16.3294 22.0002 16.1994 21.9468 16.0794Z"
            fill="#124B94"
          />
          <rect
            x="1.00684"
            y="1.29944"
            width="29.9933"
            height="30.08"
            rx="14.9967"
            stroke="#124B94"
            strokeWidth="2"
          />
        </svg>
      </a>
    </article>
  )
}
